





















































































import {
  reactive,
  watch,
  onMounted,
  computed,
  defineComponent,
  SetupContext,
} from '@vue/composition-api';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import { useStore } from '@/components/composables/useStore';
import { watchItems } from '@/components/composables/getItems';
import Entity from '@/models/entities/Entity';
import { EntityType } from '@/store/entityModules/types';
import { IDropdownFilter, ITableHeader, ICheckboxFilter } from '@/models/filters/Filters';
import { getEntityStorePath } from '@/store/entityModules/utils';
import Pagination from './Pagination.vue';
import TableHeader from './TableHeader.vue';

interface Props {
  headers: ITableHeader[];
  entityType: EntityType;
  filtersDropdown: IDropdownFilter[];
  filterCheckbox: ICheckboxFilter;
  noNewItems: boolean;
  title?: string;
  addCustomPath?: string;
}

const Component = defineComponent({
  name: 'EntityTable',

  components: {
    Pagination,
    TableHeader,
  },

  props: {
    headers: Array,
    entityType: String,
    filtersDropdown: [],
    filterCheckbox: Object,
    noNewItems: Boolean,
    title: String,
    addCustomPath: String,
  },

  setup(props: Props, { root: { $router } }: SetupContext) {
    const store: Store<RootState> = useStore();
    const storePath = getEntityStorePath(props.entityType);

    onMounted(() => {
      const searchHeaders = searchableHeaders(props.headers);
      if (searchHeaders.length > 0)
        store.dispatch(`${storePath}/setSearchHeaders`, searchableHeaders(props.headers));
      store.dispatch(`${storePath}/setQueryFiltering`, null);
    });

    const state = reactive({
      loading: computed(() => store.getters[`${storePath}/loading`]),
      items: computed(() => store.getters[`${storePath}/items`]),
      total: computed(() => store.getters[`${storePath}/total`]),
      editableHeaders: editableHeaders(props.headers),
      options: {
        page: store.getters[`${storePath}/queryPage`],
        itemsPerPage: store.getters[`${storePath}/queryRowsPerPage`],
        sortBy: [],
        sortDesc: [],
      },
    });

    watchItems(storePath);

    // update module sorting query (sortBy) if sorting changed in table
    watch(
      () => state.options,
      (newVal, oldVal) => {
        if (newVal.sortBy !== oldVal.sortBy || newVal.sortDesc !== oldVal.sortDesc) {
          const { sortBy, sortDesc } = newVal;
          store.dispatch(`${storePath}/setQuerySorting`, {
            sortBy: sortBy[0],
            descending: !!sortDesc[0],
          });
        }
      },
      { immediate: false },
    );

    function searchableHeaders(headers: ITableHeader[]) {
      return headers.filter((header: ITableHeader) => header.searchable);
    }

    function editableHeaders(headers: ITableHeader[]) {
      return headers.filter((header: ITableHeader) => header.editable);
    }

    async function showDialog(item: Entity) {
      if (props.addCustomPath)
        $router.push($router.currentRoute.path + `/${props.addCustomPath}/${item.id}`);
      else $router.push($router.currentRoute.path + `/${item.id}`);
    }

    return {
      state,
      showDialog,
      storePath,
    };
  },
});
export default Component;
